import { render } from "./BeatdayUsage.vue?vue&type=template&id=9867811c"
import script from "./BeatdayUsage.vue?vue&type=script&lang=js"
export * from "./BeatdayUsage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__